<template>
    <div class="box" v-if="info">
      <div class="box">
      <FansText :str="age"></FansText>
      <div class="fans">
          <div id="fansage" ref="chart"></div>
      </div>
    </div>
    </div>
    <div v-else class="chart">
    <none-data :height="3.5" />
  </div>
  </template>
  
  <script>
  import FansText from "@/components/FansText.vue";
  export default {
      props: {
      info: { type: Object },
    },
    components: { FansText },
    data() {
      return {}
    },
    computed:{
     age() {
        if(this.info) {
          const obj = this.info
          if(obj&&Array.isArray(obj)) return []
          const topList=Object.entries(obj).map(([name,value])=>({name,value:Number(value||0)})).sort((a, b) => b.value - a.value).slice().splice(0,1)//排序取前4
          const ageRange = topList[0].name.replace("+","多").replace("nuder","未满")
          return`${ ageRange}岁年龄段的粉丝居多，在${ ageRange}岁年龄段粉丝中具有优势`
        }
      }
    },
    methods: {
        setChart() {
      const data = [];
      const abbr = this.info;
      for (const key in abbr) {
        let name = key + '岁';
        // 传回的数据顺序不太对，需要sort
        let index = key.split('-')[0];
        if (key === 'under18') {
          name = '18岁以下';
          index = 0;
        }
        if (key === '50+') {
          name = '50岁以上';
          index = 50;
        }
        data.push({ name, value: (abbr[key] * 100).toFixed(2), index });
      }
      data.sort((a, b) => a.index - b.index);
      this.drawChart(data);
    },
          // 字体适配
  FontChart(res) {
          //获取到屏幕的宽度
          var clientWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth; 
          if (!clientWidth) return; //报错拦截：
          let fontSize = 10 * (clientWidth / 1920);
          return res * fontSize;
        },
      drawChart(data) {
        const color = ['#F5A623', '#2A89F4'];
        echarts.init(document.getElementById('fansage')).setOption({
        color,
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: val => {
            return `<div style="display: inline-block;margin-right: 5px;border-radius: 5px;width: 10px;height:10px;background:linear-gradient(180deg,rgba(42,137,244,1) 0%,rgba(187,219,255,1) 100%);"></div>
            ${val[0].name} ${val[0].value}%`;
          }
        },
        legend: {
          data: ['年龄分布'],
          bottom: 0
        },
        grid: {
          left: this.FontChart(20),
          top: this.FontChart(15),
          bottom: this.FontChart(10),
          right: this.FontChart(20)
        },
        xAxis: [
          {
            type: 'category',
            data: data.map(e => e.name),
            axisLabel: { textStyle: { color: '#848F9C',fontSize:this.FontChart(4)} },
            axisLine: { lineStyle: { color: '#848F9C' } },
            axisTick: { color: '#848F9C' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            axisLabel: {
              formatter: '{value}%',
              textStyle: { color: color[0],fontSize:this.FontChart(4) }
            },
            ...this.noneChart
          }
        ],
        series: [
          {
            name: '粉丝年龄分布',
            type: 'bar',
            data,
            barMaxWidth: this.FontChart(10),
            label: {
              show: true,
              formatter: val => val.value + '%',
              position: 'top',
              color: '#848F9C',
              fontSize: this.FontChart(6)
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2A89F4' },
                  { offset: 1, color: '#BBDBFF' }
                ])
              }
            }
          }
        ]
      });
    }
  },
  mounted() {
    if(this.info && this.info !== {}) {
        this.setChart();
    }
    },
  }
  </script>
  
  <style scoped lang='less'>
  #fansage {
    width: 100%;
    height: 170px;
  }

  .chart{
  width: 100%;
  height: 220px;
  justify-content: center;
  align-items: center;
  display: flex;
}
  </style>
  
